import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <Container fluid className="d-flex vh-100 align-items-center justify-content-center bg-light">
      <Row className="text-center">
        <Col>
          <h1 className="display-1 fw-bold text-danger">404</h1>
          <h2 className="mb-3">Page Not Found</h2>
          <p className="text-muted mb-4">
            Oops! The page you are looking for doesn’t exist or has been moved.
          </p>
          <Button as={Link} to="/" variant="primary">
            Go Back Home
          </Button>
        </Col>
      </Row>
    </Container>
  );
}